/*
  Shopify Forms Custom Styling Injector

  Shopify Forms renders inside a Shadow DOM, so theme CSS cannot target it directly.
  This script waits for the form to mount, accesses the shadowRoot, and injects custom styles.

  Scoped by `data-forms-id` to safely target a specific form instance.
  Uses MutationObserver to handle async rendering and prevents duplicate injections.

  Safe, reusable, and aligned with Shopify’s current Forms architecture.
*/

function styleShopifyFormByWrapper({ wrapperId, debug = false }) {
  const log = (...args) => debug && console.log("[ShopifyFormStyle]", ...args);

  document.addEventListener("DOMContentLoaded", () => {
    const observer = new MutationObserver(() => {
      const wrapper = document.querySelector(`[data-forms-id="${wrapperId}"]`);
      if (!wrapper) return;

      const formEmbed = wrapper.querySelector("shopify-forms-embed");
      if (!formEmbed || !formEmbed.shadowRoot) return;

      if (formEmbed.shadowRoot.querySelector("style[data-custom-style]")) {
        observer.disconnect();
        return;
      }

      

const shadow = formEmbed.shadowRoot;

/* ===== LOAD GOOGLE FONTS INSIDE SHADOW DOM ===== */
if (!shadow.querySelector('link[data-custom-fonts]')) {
  const fontLink = document.createElement('link');
  fontLink.setAttribute('data-custom-fonts', 'true');
  fontLink.rel = 'stylesheet';
  fontLink.href = 'https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Barlow+Condensed:wght@400;500;600;700;900&family=Barlow:wght@300;400;500&display=swap';
  shadow.appendChild(fontLink);
}

/* ===== FORCE PLACEHOLDERS ===== */
const placeholderMap = {
  email: "your@email.com",
  first_name: "Your full name",
  phone_number: "+61 000 000 000"
};

Object.entries(placeholderMap).forEach(([id, text]) => {
  const input = shadow.querySelector(`#${id}`);
  if (input) input.setAttribute("placeholder", text);
});

/* ===== INJECT CUSTOM LABELS ===== */
const fields = [
  { id: "email", label: "EMAIL ADDRESS" },
  { id: "first_name", label: "FULL NAME" },
  { id: "phone_number", label: "PHONE NUMBER" }
];

fields.forEach(({ id, label }) => {
  const input = shadow.querySelector(`#${id}`);
  if (!input) return;

  const phoneContainer = input.closest('._formPhoneInputContainer_piv1u_6');

  // ===== PHONE FIELD (special case) =====
  if (phoneContainer) {
    if (phoneContainer.querySelector('.custom-label')) return;

    const labelEl = document.createElement('label');
    labelEl.className = 'custom-label';
    labelEl.textContent = label;

    // 🔥 insert at VERY TOP of phone container
    phoneContainer.insertBefore(labelEl, phoneContainer.firstChild);

    return;
  }

  // ===== NORMAL FIELDS =====
  const fieldContainer = input.closest('._formFieldContainer_1mxsl_5');
  if (!fieldContainer || fieldContainer.querySelector('.custom-label')) return;

  const labelEl = document.createElement('label');
  labelEl.className = 'custom-label';
  labelEl.textContent = label;

  fieldContainer.insertBefore(labelEl, fieldContainer.firstChild);
});


      const style = document.createElement("style");
      style.setAttribute("data-custom-style", "true");

      style.textContent = `


      ._selectToggle_12thd_25 {
      max-height: 221px !important;
      }

/* ===== WIDTH / LAYOUT ===== */
#form-container-ref {
  max-width: 640px !important;
  margin: 0 auto !important;
}

/* ===== FORM ===== */
form[data-testid="form"] {
  display: flex !important;
  flex-direction: column !important;
  gap: 16px !important;
}

/* ===== FIELD WRAPPER ===== */
._formFieldContainer_1mxsl_5 {
  display: flex !important;  
  gap: 8px !important;
}

/* ===== LABEL ===== */
._formInputFieldLabel_1mxsl_38 {
  position: static !important;
  transform: none !important;
  top: auto !important;

  font-family: 'Barlow Condensed', sans-serif !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  letter-spacing: 4px !important;
  text-transform: uppercase !important;

  color: #666 !important;
  margin-bottom: 4px !important;
}

/* REMOVE FLOATING BEHAVIOR */
._inputFilled_1mxsl_74 {
  transform: none !important;
}

/* ===== INPUT ===== */
._formInputField_nag3b_7,
._formPhoneInputField_piv1u_17 {
  background: #141414 !important;
  border: 1px solid rgba(255,255,255,0.1) !important;
  color: #ffffff !important;

  font-family: 'Barlow', sans-serif !important;
  font-size: 15px !important;

  padding: 16px 20px !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  height: auto !important;
}

._formInputField_nag3b_7:focus,
._formPhoneInputField_piv1u_17:focus {
color: #fff !important;
}

/* PLACEHOLDER */
input::placeholder {
  color: #444 !important;
  opacity: 1 !important;
}

/* FOCUS */
input:focus {
  border-color: rgba(255,255,255,0.4) !important;
  outline: none !important;
}

/* ===== PHONE FIELD ===== */
._formPhoneInputContainer_piv1u_6 {
  display: flex !important;
  align-items: stretch !important;
  gap: 8px !important;
}

._selectToggle_12thd_25 {
  background: #141414 !important;
  border: 1px solid rgba(255,255,255,0.1) !important;
  border-radius: 0 !important;
  padding: 0 12px !important;
}

/* ===== BUTTON ===== */
._formSubmitButton_cit2d_96 {
all: revert !important;
  margin-top: 8px !important;

  background: #f0f0f0 !important;
  color: #080808 !important;

  font-family: 'Barlow Condensed', sans-serif !important;
  font-size: 15px !important;
  font-weight: 700 !important;
  letter-spacing: 3px !important;
  text-transform: uppercase !important;

  padding: 18px 40px !important;

  border: none !important;
  width: 100% !important;

  display: flex !important;
  justify-content: center !important;
  align-items: center !important;

  clip-path: polygon(
    0 0,
    calc(100% - 12px) 0,
    100% 12px,
    100% 100%,
    12px 100%,
    0 calc(100% - 12px)
  ) !important;

  transition: transform 0.2s ease, box-shadow 0.2s ease !important;
}

._formSubmitButton_cit2d_96:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 14px 40px rgba(255,255,255,0.15) !important;
  cusrsor: pointer !important;
}

/* ===== DISCLAIMER ===== */
._formDisclaimer_cit2d_38 p {
  font-family: 'Barlow Condensed', sans-serif !important;
  font-size: 15px !important;
  color: #666 !important;
  text-align: center !important;
  margin-top: 12px !important;
}

/* ===== REMOVE EXTRA SPACING SHOPIFY ADDS ===== */
._gridItemContent_1q1d2_257 {
  padding: 0 !important;
}

button._formSubmitButton_cit2d_96:focus-visible, button._formSubmitButton_cit2d_96:hover {
    filter: none !important;
}

._formSubmitButton_cit2d_96 {
cursor: pointer !important;
}

section._formContainer_1q1d2_30._grid_1q1d2_148._noImage_1q1d2_161 {
    max-width: 100% !important;
}

._formInputFieldLabel_1mxsl_38 {
  display: none !important;
}



/* ===== CUSTOM LABEL ===== */
.custom-label {
  font-family: 'Barlow Condensed', sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 4px;
  text-transform: uppercase;
  color: #666;
  display: block;
  text-align: left;
}

/* ===== PHONE FIELD CLEAN LAYOUT ===== */
._formPhoneInputContainer_piv1u_6 {
  display: flex !important;
  flex-direction: column !important;
  gap: 8px !important;
}

/* Row layout */
._formPhoneInputContainer_piv1u_6 > div:last-child {
  display: flex !important;
  gap: 8px !important;
}

/* Selector */
._selectToggle_12thd_25 {
  min-width: 48px !important;
  max-width: 60px !important;

  display: flex !important;
  align-items: center !important;
  justify-content: center !important;

  background: #141414 !important;
  border: 1px solid rgba(255,255,255,0.1) !important;
  border-radius: 0 !important;
}
._selectToggleText_12thd_25 {
justify-content: flex-end !important;
}
/* Input */
._formPhoneInputField_piv1u_17 {
  flex: 1 !important;
}

/* ===== PHONE FIELD (GRID - CLEAN SOLUTION) ===== */

._formPhoneInputContainer_piv1u_6 {
  display: grid !important;

  grid-template-columns: 60px 1fr !important; /* selector + input */
  grid-template-rows: auto auto !important;

  gap: 8px !important;
  width: 100% !important;
}

/* ===== LABEL (FULL WIDTH TOP) ===== */
._formPhoneInputContainer_piv1u_6 > .custom-label {
  grid-column: 1 / -1 !important; /* span both columns */
}

/* ===== SELECTOR (LEFT) ===== */
.phone-country-selector {
  grid-column: 1 !important;
  grid-row: 2 !important;
}

/* ===== INPUT WRAPPER (RIGHT) ===== */
._formPhoneInputContainer_piv1u_6 > ._formFieldContainer_1mxsl_5 {
  grid-column: 2 !important;
  grid-row: 2 !important;
}

/* ===== SELECTOR STYLE ===== */
._selectToggle_12thd_25 {
  height: 100% !important;
  min-height: 52px !important;

  display: flex !important;
  align-items: center !important;
  justify-content: center !important;

  background: #141414 !important;
  border: 1px solid rgba(255,255,255,0.1) !important;
  border-radius: 0 !important;
  padding: 0 !important;
}

/* DEFAULT = dim */
._formPhoneInputField_piv1u_17 {
  color: #444 !important;
}

/* ACTIVE = user entered something */
._formPhoneInputField_piv1u_17.has-value {
  color: #f0f0f0 !important;
}
  
h2._formBannerHeading_z5ku3_9,
._textBody_2aowh_10 {
    text-align: center !important;
    font-family: 'Barlow Condensed', sans-serif !important;
    font-size: 17px !important;
    margin-bottom: 48px !important;
    line-height: 1.6 !important;
    display: block !important;
    margin-bottom: 0.5em !important;
}


h2._formBannerHeading_z5ku3_9 {
font-size: 16px !important;
    font-weight: 700 !important;
    letter-spacing: 1px !important;
    text-transform: uppercase !important;
}

span._spinner_10n5y_7, span._spinner_10n5y_7 svg {
    color: #333 !important;
}

span._spinner_10n5y_7 svg path {
fill: #333 !important;
}

._formError_1mxsl_21 {
    text-align: left !important;
    font-weight: 400 !important;
    font-family: 'Barlow Condensed', sans-serif  !important;
}
`;

      formEmbed.shadowRoot.appendChild(style);
      log("Injected improved layout + styling.");

      const phoneInput = shadow.querySelector('#phone_number');

if (phoneInput) {

  const updateState = () => {
    const val = phoneInput.value.trim();

    // Extract dial code dynamically
    const match = val.match(/^\+\d+/);
    const dial = match ? match[0] : '';

    const isOnlyDial = val === dial || val === dial + '';

    if (isOnlyDial) {
      phoneInput.classList.remove('has-value');
    } else {
      phoneInput.classList.add('has-value');
    }

    console.log('[PHONE STATE]', {
      value: val,
      dial,
      isOnlyDial
    });
  };

  // Run once (no timeout needed)
  updateState();

  // Events that actually fire (from your logs)
  phoneInput.addEventListener('input', updateState);
  phoneInput.addEventListener('focus', updateState);
  phoneInput.addEventListener('blur', updateState);
}


      observer.disconnect();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
}

styleShopifyFormByWrapper({
  wrapperId: "forms-root-927182",
  debug: false
});
